import { ValueOf } from '@/types/common';

export const TASK_STATUSES_LOADING = {
    Uploading: 'Uploading',
    Pending: 'Pending',
    Processing: 'Processing',
} as const;

export const TASK_STATUSES_COMPLETED = {
    Completed: 'Completed',
    Failed: 'Failed',
    FailedAll: 'FailedAll',
    WaitingUser: 'WaitingUser',
} as const;

export const TASK_STATUSES = {
    ...TASK_STATUSES_LOADING,
    ...TASK_STATUSES_COMPLETED,
} as const;

export type TaskStatusT = ValueOf<typeof TASK_STATUSES>;
